import { useTheme } from '../context/ThemeContext';
import { Sun, Moon } from 'react-feather';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="theme-toggle"
      title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
      style={{
        background: 'var(--bg-elevated)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius)',
        padding: '8px 12px',
        color: 'var(--text-muted)',
        cursor: 'pointer',
        fontSize: '18px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s',
      }}
      onMouseEnter={(e) => {
        e.target.style.borderColor = 'var(--accent)';
        e.target.style.color = 'var(--text)';
      }}
      onMouseLeave={(e) => {
        e.target.style.borderColor = 'var(--border)';
        e.target.style.color = 'var(--text-muted)';
      }}
    >
      {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
}
